import { MatchHistoryType } from '@nkr/enums/match-history-type';
import { IMatchDeadline } from '@nkr/models/match-deadline';
import { Button, Modal, Table } from 'react-bootstrap'

interface IProps {
    show: boolean,
    data: IMatchDeadline,
    type: MatchHistoryType,
    onYes: () => void,
    onNo: () => void
}

const ConfirmNoResponse = (props: IProps) => {
    const type = props.type == MatchHistoryType.MatchOffer ? 'MATCH OFFER' : 'DONOR CLEARANCE';
    const chainId = props.data != null ? props.data.chainId : 0;
    const clusterNumber = props.data != null ? props.data.clusterNumber : 0;
    const positionNumber = props.data != null ? props.data.positionNumber : 0;
    const donorAlias = props.data != null ? props.data.donorAlias : '';
    const donorCenter = props.data != null ? props.data.donorCenter : '';
    const recipientAlias = props.data != null ? props.data.recipientAlias : '';
    const recipientCenter = props.data != null ? props.data.recipientCenter : '';
    const deadlineDateTime = props.data != null ? props.data.deadlineDateTime : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm "NO RESPONSE" for {type}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 10 }}>Are you sure you want to mark <strong>no response</strong> for the following {type}?</div>
                <Table bordered condensed style={{ marginBottom: 0 }}>
                    <tbody>
                        <tr>
                            <td>Swap:</td>
                            <td>{chainId}/{clusterNumber}/{positionNumber}</td>
                        </tr>
                        <tr>
                            <td>Donor:</td>
                            <td>{donorAlias} @ {donorCenter}</td>
                        </tr>
                        <tr>
                            <td>Recipient:</td>
                            <td>{recipientAlias} @ {recipientCenter}</td>
                        </tr>
                        <tr>
                            <td>Deadline:</td>
                            <td>{deadlineDateTime}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes</Button>
                <Button onClick={props.onNo}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmNoResponse;